/**
 * MIRAK hero slider: an auto-advancing crossfade between the hero's stacked
 * background images, with a row of dots for manual navigation — no arrows.
 * Only runs when the section has at least one extra slide block
 * (mirak-hero.liquid only renders this script tag in that case); a single
 * static image is untouched. Auto-advance is disabled under
 * prefers-reduced-motion, but the dots still work — clicking one just swaps
 * instantly instead of crossfading (the transition itself is scoped to
 * no-preference in CSS).
 */

const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

function initHeroSlider(frame) {
  const slides = Array.from(frame.querySelectorAll('.mirak-image-hero__image'));
  const contents = Array.from(frame.querySelectorAll('.mirak-image-hero__content'));
  const dots = Array.from(frame.querySelectorAll('[data-mirak-hero-dot]'));
  if (slides.length < 2) return;

  let index = slides.findIndex((slide) => slide.classList.contains('is-active'));
  if (index < 0) index = 0;

  const goTo = (next) => {
    if (next === index) return;
    slides[index].classList.remove('is-active');
    slides[next].classList.add('is-active');
    if (contents[index]) contents[index].classList.remove('is-active');
    if (contents[next]) contents[next].classList.add('is-active');
    if (dots[index]) {
      dots[index].classList.remove('is-active');
      dots[index].setAttribute('aria-current', 'false');
    }
    if (dots[next]) {
      dots[next].classList.add('is-active');
      dots[next].setAttribute('aria-current', 'true');
    }
    index = next;
  };

  let timer = null;

  const startAutoplay = () => {
    if (reduceMotionQuery.matches) return;
    const durationVar = getComputedStyle(frame).getPropertyValue('--mirak-hero-slide-duration');
    const seconds = parseFloat(durationVar) || 5;
    timer = setInterval(() => goTo((index + 1) % slides.length), seconds * 1000);
  };

  const restartAutoplay = () => {
    if (timer) clearInterval(timer);
    startAutoplay();
  };

  dots.forEach((dot, dotIndex) => {
    dot.addEventListener('click', () => {
      goTo(dotIndex);
      restartAutoplay();
    });
  });

  startAutoplay();
}

document.querySelectorAll('[data-mirak-hero-slider]').forEach(initHeroSlider);
